import { DateCalendar, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';
import { makeSelectedEvent } from 'app/pages/TicketSalePage/slice/selectors';
import { DateTime } from 'luxon';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useCalendarController } from './calendarContext';
import CalendarDay from './CalendarDay';
import { selectVendorFeatures } from 'store/vendorSlice/selectors';

interface DateCalendarWrapperProps {
  handleClose?: () => void;
}

const DateCalendarWrapper: React.FC<DateCalendarWrapperProps> = ({
  handleClose,
}) => {
  const { displayCalendarInsidePageLayout } = useSelector(selectVendorFeatures);
  const {
    dateTimeFormat: { timezone },
    calendar,
    reservedTickets,
  } = useSelector(makeSelectedEvent);
  const { selectedDate } = useCalendarController();
  const [firstAvailableDate] = useState(selectedDate);

  const now = DateTime.now()
    .setZone(timezone)
    .set({ hour: 0, minute: 0, second: 0, millisecond: 0 });

  return (
    <LocalizationProvider dateAdapter={AdapterLuxon}>
      <DateCalendar
        timezone={timezone}
        views={['day']}
        minDate={firstAvailableDate}
        disableHighlightToday
        dayOfWeekFormatter={date => date.toFormat('ccc').toString()}
        slots={{
          day: CalendarDay,
        }}
        slotProps={{
          day: {
            calendar,
            reservedTickets,
            now,
            handleClose,
          } as any,
        }}
        sx={
          displayCalendarInsidePageLayout
            ? theme => ({
                '&.MuiDateCalendar-root': {
                  width: '100%',
                  minHeight: '390px',
                  '& .MuiPickersSlideTransition-root': {
                    minHeight: '390px',
                  },
                  '& .MuiPickersDay-root': {
                    height: '38px',
                    width: '38px',
                    fontSize: '0.8rem',
                  },
                  '& .MuiDayCalendar-weekContainer, & .MuiDayCalendar-header': {
                    justifyContent: 'space-between',
                    paddingInline: '24px',
                    marginBottom: '10px',
                  },
                  [theme.breakpoints.up(420)]: {
                    '& .MuiPickersDay-root': {
                      height: '44px',
                      width: '44px',
                      fontSize: '1.2rem',
                    },
                    minHeight: '440px',
                    '& .MuiPickersSlideTransition-root': {
                      minHeight: '440px',
                    },
                  },
                },
              })
            : null
        }
      />
    </LocalizationProvider>
  );
};

export default DateCalendarWrapper;
